import { createContext } from "@lit/context";

export const NoClampActionContext = createContext<boolean>("no-clamp-action-context");

export const SystemBannerChildCountContext = createContext<boolean>("system-banner-children-count-context");
